import './App.css';
import Dashboard from '../Dashboard'
import Login from '../Login'
import Register from '../Register'
import {HashRouter as Router,Switch,Route} from "react-router-dom";
import {store} from '../../../config/redux'
import {Provider} from 'react-redux'

function App() {
  return (
    <Provider store={store}>
      <Router basename='/'>
          <Switch>
              <Route path="/" exact component={Dashboard}/>
              <Route path="/login" component={Login}/>
              <Route path="/register" component={Register}/>
          </Switch>
      </Router>
    </Provider>
  );
}

export default App;
